<div [ngClass]="{'card mb-2 wow detalle-cliente': true, disabledContent: !enabled}">
  <div class="card-body justify-content-between">
    <div class="row filtros-header" style="
          border-bottom: 1px solid #dee2e6;
          justify-content: space-between;
          align-items: center;
        ">
      <h4>
        Formas de pago
      </h4>
    </div>

    <div class="table-responsive mt-1">
      <table class="table table-striped table-hover table-sm align-middle">
        <thead class="grey lighten-2">
          <tr>
            <th scope="col">
              <mdb-checkbox (change)="checkAllPagos($event)"></mdb-checkbox>
            </th>
            <th scope="col">Tipo abono</th>
            <th scope="col">Descripción</th>
            <th scope="col">Nro. Documento</th>
            <th scope="col" class="text-right">Monto</th>
          </tr>
        </thead>
        <tbody *ngIf="formasPagoData && formasPagoData.forma_pago.length > 0">
          <tr *ngFor="let formaPago of formasPagoData.forma_pago">
            <td>
              <mdb-checkbox [checked]="formaPago.checked" (change)='checkPago(formaPago)'></mdb-checkbox>
            </td>
            <td>{{formaPago.tipo_pago_nombre}}</td>
            <td>{{formaPago.banco_nombre}}</td>
            <td *ngIf="formaPago.tipo_pago_codigo != 2 && formaPago.numero_doc > 0">{{formaPago.numero_doc}}</td>
            <td *ngIf="formaPago.tipo_pago_codigo == 2 || formaPago.numero_doc == 0"></td>
            <td align="right">$ {{formaPago.monto | numerico}}</td>
          </tr>
        </tbody>
        <tbody class="blue lighten-5" *ngIf="formasPagoData && formasPagoData.forma_pago.length > 0">
          <tr>
            <td align="right" colspan="4">
              <strong>Total forma de pago</strong>
            </td>
            <td align="right">
              <strong>$ {{formasPagoData.total_forma_pago | numerico}}</strong>
            </td>
          </tr>
          <tr>
            <td align="right" colspan="4">
              <strong>Saldo</strong>
            </td>
            <td class="text-right"><strong>$ {{SaldoPago | numerico}}</strong></td>
          </tr>
          <!-- <tr>
            <td align="right" colspan="4">
              <strong>Diferencia a pago a cuenta</strong>
            </td>
            <td align="right">
              <strong>$ {{formasPagoData.diferencial_pago | numerico}}</strong>
            </td>
          </tr> -->
        </tbody>
      </table>
    </div>
  </div>

  <!-- FOOTER -->
  <div class="card-footer text-muted filtros-footer" style="border-top: 1px solid #dee2e6;">
    <button mdbBtn type="button" color="warning" size="sm" mdbWavesEffect (click)="eliminarPagos()">
      Eliminar
    </button>
    <div></div>
  </div>
</div>
